module.exports = __webpack_public_path__ + "media/images/obat-0f5e6563.svg";